declare global{
    interface Number {
        rounded(precision?:number): number;
    }
}

Number.prototype.rounded = function(precision:number = 0){   
    if(precision == 0)
        return Math.round(this as number)
    return Math.round((this as number) * (precision*10)) / (precision*10)
}
